<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${userId ? 'Edit' : 'Add New'} User`" />

    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="userId" class="custom-label">ID</label>
            <input id="userId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="form-group">
            <label for="username" class="custom-label">First Name</label>
            <input id="username" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.firstname">
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="form-group">
            <label for="username" class="custom-label">Last Name</label>
            <input id="username" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.lastname">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="username" class="custom-label">Username</label>
            <input id="username" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.username" @input="clearErrorMessage">
            <small v-if="errorMessage" class="text-danger " style="font-size: 11px;">{{ errorMessage }}</small>
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="form-group">
            <label for="email" class="custom-label">Email</label>
            <input id="email" type="email" class="form-control shadow-none custom-input" placeholder="Enter email"
              v-model="saveData.email">
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="form-group">
            <label for="username" class="custom-label">Phone Number</label>
            <input id="username" type="tel" class="form-control shadow-none custom-input"
              placeholder="Enter phone number" v-model="saveData.phonenumber">
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="form-group">
            <label for="password" class="custom-label">Password</label>
            <input id="password" type="password" class="form-control shadow-none custom-input"
              placeholder="Enter password" v-model="saveData.password" @input="validatePasswords">
          </div>
        </div>
        <div class="col-md-3 ">
          <div class="form-group">
            <label for="confirmPassword" class="custom-label">Confirm Password</label>
            <input id="confirmPassword" type="password" class="form-control shadow-none custom-input"
              placeholder="Enter password" v-model="confirmPassword" @input="validatePasswords">
            <small v-if="passwordMismatch" class="text-danger" style="font-size: 11px;">Passwords do not match!</small>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="custom-label">User Type ID</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.usertypeid">
              <option v-for="userType in userTypes" :key="userType.uuid" :value="userType.uuid">{{ userType.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="custom-label">Role</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.roleid">
              <option v-for="role in roles" :key="role.uuid" :value="role.uuid">{{ role.name }}</option>
            </select>
          </div>
        </div>

        <div class="mb-3 col-md-3">
          <label for="formFileSm" class="custom-label">Profile Picture</label>
          <input class="form-control shadow-none form-control custom-label" id="formFileSm" type="file">
        </div>
        <div class="mb-3 col-md-9"></div>
        <div class="row align-items-center">
          <div class="col-md-3 " :class="{'mb-3': !containsComma, 'mb-2': containsComma}">
            <div class="form-group">
              <label class="custom-label">Profile Links</label>
              <div class="custom-multiple-dropdown-wrapper">
                <input id="username" class="form-control shadow-none custom-input" placeholder="Enter URL"
                  v-model="saveData.profilelinks"  @input="checkForComma">
                <button class="multiple-dropdown-add-button" @click="addProfileLink" :disabled="containsComma">+</button>
              </div>
                 <small v-if="containsComma" class="text-danger" style="font-size: 11px;">Commas are not allowed in profile links.</small>
            </div>
          </div>

          <div class="col-md-9 mb-3 align-self-end custom-input">
            <div class="custom-multiple-dropdown-container">
              <div v-for="(link, index) in addURLs" :key="index">
                <span class="custom-multiple-dropdown"> {{ link }}
                  <button class="multiple-dropdown-delete-icon" @click="removeProfileLink(index)">
                    <dropdownDeleteIcon />
                  </button>
                </span>
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeDesc" class="custom-label">Description</label>
            <textarea id="assetTypeNote" class="form-control shadow-none custom-input" rows="4" placeholder="Enter text"
              v-model="saveData.description"></textarea>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" class="form-control shadow-none custom-input" rows="4" placeholder="Enter text"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.userId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>

        <!-- Modal -->
        <deleteModal v-if="this.userId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.userId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button" :disabled="passwordMismatch || containsComma"
              @click="addUserData()">Submit</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { addUser, getByIdUser, updateUser, ddUserType, ddRole } from '@/http/user-mgmt/user.http'
import deleteModal from '@/components/delete-modal.vue';
import dropdownDeleteIcon from '@/components/dropdown-delete-icon.vue';
export default {
  name: 'user-type-form',
  components: {
    Header,
    Subheader,
    deleteModal,
    dropdownDeleteIcon
  },
  data() {
    return {
      // titleConfig:"Add Asset Type",
      userId: this.$route.params.id,
      containsComma: false, 
      saveData: {},
      userTypes: [],
      roles: [],
      confirmPassword: '',
      passwordMismatch: false,
      errorMessage: "",
      addURLs: [],
      profilelinks: '',
      breadcrumsfirst: "User Management",
      breadcrumslast: "User",

    }
  },
mounted() {
  this.getUserTypeDropdownData();
  this.getRoleDropdownData();
  if (this.userId) {
  getByIdUser(this.$route.params.id).then((res) => {
    this.saveData = res;
    // Filter out empty or whitespace-only strings
    this.addURLs = Array.isArray(res.profilelinks)
      ? res.profilelinks.filter(link => link.trim() !== '')
      : [];
    this.saveData.profilelinks = ''; // Clear input field
  }).catch((error) => {
    console.log("Error fetching User Data:", error)
  });
}
},
  methods: {
      checkForComma() {
    // Check if there's a comma in the profile links input
    this.containsComma = this.saveData.profilelinks.includes(',');
  },
    validatePasswords() {
      this.passwordMismatch = this.saveData.password !== this.confirmPassword;
    },
    addUserData() {
      this.saveData.profilelinks = this.addURLs.join(',');
      if (this.userId) {
        const payload = {
          uuid: this.$route.params.id,
        };
        updateUser({ ...payload, ...this.saveData }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/usermanagement/user")
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        addUser(this.saveData).then(() => {
          this.$router.push("/usermanagement/user")
        }).catch(error => {
          if (error.response && error.response.status === 401 && error.response.data && error.response.data.message === "user already exist") {
            // Store error message
            this.errorMessage = "User already exist";
          } else {
            console.error('Error adding user:', error);
          }
        });
      }

    },
    getUserTypeDropdownData() {
      // Fetch assets
      ddUserType()
        .then(response => {
          this.userTypes = response;
          // Set default value for parentassetid
          if (this.userTypes.length > 0) {
            // Check if assetId is set and update parentassetid accordingly
            if (this.userId) {
              const index = this.userTypes.findIndex(user => user.uuid === this.saveData.usertypeid);
              if (index !== -1) {
                this.saveData.usertypeid = this.userTypes[index].uuid;
              }
            } else {
              this.saveData.usertypeid = this.userTypes[0].uuid;
            }
          }
        })
        .catch(error => {
          console.error('Error fetching assets:', error);
        });
    },
    getRoleDropdownData() {
      // Fetch assets
      ddRole()
        .then(response => {
          this.roles = response;
          // Set default value for parentassetid
          if (this.roles.length > 0) {
            // Check if assetId is set and update parentassetid accordingly
            if (this.userId) {
              const index = this.roles.findIndex(role => role.uuid === this.saveData.roleid);
              if (index !== -1) {
                this.saveData.roleid = this.roles[index].uuid;
              }
            } else {
              this.saveData.roleid = this.roles[0].uuid;
            }
          }
        })
        .catch(error => {
          console.error('Error fetching role:', error);
        });
    },
    cancelButton() {
      this.$router.push("/usermanagement/user")
    },
    clearErrorMessage() {
      this.errorMessage = ""; // Clear the errorMessage
    },
    deleteRecord() {
      this.saveData.issoftdelete = 1;
      const payload = {
        issoftdelete: this.saveData.issoftdelete ? 1 : 0,
        uuid: this.$route.params.id,
      };
      updateUser({ ...payload, ...this.saveData }).then(() => {
        this.saveData.updatedon = new Date().toISOString();
        this.$router.push("/usermanagement/user")
      }).catch((error) => {
          this.error = error.message;
      });

    },
    addProfileLink() {
       if (this.containsComma) {
      return; // Prevent adding if there's a comma
    }
      if (this.saveData.profilelinks && this.saveData.profilelinks.trim()) {
        this.addURLs.push(this.saveData.profilelinks.trim());
        this.saveData.profilelinks = ''; // Clear the input field
      }
    },
    removeProfileLink(index) {
      this.addURLs.splice(index, 1);
    }
  }
}
</script>

<style scoped></style>